import { render, staticRenderFns } from "./PasswordCreate.vue?vue&type=template&id=29620c4a&scoped=true"
import script from "./PasswordCreate.vue?vue&type=script&lang=js"
export * from "./PasswordCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29620c4a",
  null
  
)

export default component.exports